export default "__VITE_PUBLIC_ASSET__ba16994b__"